import { useState } from 'react';
import SimplePopover from '@/component/SimplePopover';
import SelectIcon from '@/assets/common/ic_success_gray.svg';
import TranslateIcon from '@/assets/common/ic_translate.svg';
import { TranslationOption, translationOptionList } from '@/constants/translate';
import { IS_PRIVATE } from '@/config';

interface TranslationSelectorProps {
  translationOption: TranslationOption;
  setTranslationOption: (option: TranslationOption) => void;
  className?: string;
}

const TranslationSelector = ({
  translationOption,
  setTranslationOption,
  className = ''
}: TranslationSelectorProps) => {
  const [showMultiSelect, setShowMultiSelect] = useState(false);

  const handleOptionChange = (option: TranslationOption) => {
    setTranslationOption(option);
    setShowMultiSelect(false);
  };

  const getButtonText = () => {
    const selectedOptionData = translationOptionList.find(option => option.id === translationOption);
    return selectedOptionData ? selectedOptionData.value : '显示选项';
  };

  // 气泡内容
  const popoverContent = (
    <div className="w-36 p-2">
      <div className="flex flex-col gap-2">
        {translationOptionList.map((option) => (
          <div
            key={option.id}
            className={`w-full px-2 py-1.5 text-3 text-mx-secondary hover:bg-#191D260D rounded-1.5 cursor-pointer flex items-center justify-between`}
            onClick={() => handleOptionChange(option.id)}
          >
            <span>{option.value}</span>
            {translationOption === option.id && <img src={SelectIcon} className="w-4 h-4" />}
          </div>
        ))}
      </div>
    </div>
  );

  return (
    // TODO：私有化暂时不支持翻译功能，所以先去掉原文/译文选择
    IS_PRIVATE ? null : (
      <SimplePopover
        visible={showMultiSelect}
        onVisibleChange={setShowMultiSelect}
        content={popoverContent}
        placement="center"
      >
        <div
          className={`flex items-center h-8 text-mx-secondary no_drag cursor-pointer ${className}`}
          style={{ width: "auto", minWidth: "fit-content" }}
        >
          <img src={TranslateIcon} className="w-4.5 h-4.5 mr-1" />
          <span className="text-3.5 truncate">{getButtonText()}</span>
        </div>
      </SimplePopover>
    )
  );
};

export default TranslationSelector; 